<form [formGroup]="form">
    <table class="widget-settings_wrap">
        <!-- Widget Name -->
        <tr class="field">
            <td>
                <label class="label-text" for="widget_name">
                    {{'components.widgets.common.settings_widget_name' | l10n}}
                </label>
            </td>
            <td>
                <input class="text-input" type="text" id="widget_name" [formControl]="form.controls.title" autofocus />
            </td>
        </tr>

        <!-- Tranche -->
        <tr class="field">
            <td>
                <label class="label-text" #trancheLabel>
                    Tranche
                </label>
            </td>
            <td>
                <select-input
                    [formControl]="form.controls.trancheSymbol"
                    [selectMenuItems]="$trancheSymbolSelectItems()"
                    [labelElement]="trancheLabel">
                </select-input>
            </td>
        </tr>
    </table>
</form>
